import { makeAutoObservable } from 'mobx';

export class PaywallFlowStore {
  meta = '';

  constructor() {
    makeAutoObservable(this);
  }

  setMeta(nextMeta: string): void {
    this.meta = nextMeta;
  }

  clear(): void {
    this.meta = '';
  }
}

export const paywallFlowStore = new PaywallFlowStore();
